<template>
	<sf-modal-layout class="qms-xxl" :title="clamMstPopUpInfo.title" :show="display" :closeModal="close">
		<div class="sf-actions">
			<div className="sf-actions__left">
				<template v-if="clamMstPopUp.btnApprAuth">
					<!--승인-->
					<sf-button size="sm" v-if="isButton_(scrId, 'CS')" line icon="round-check-on" :onClick="apprSaveAction">
						{{ getMessage_('QWCC001001') }}
					</sf-button>

					<!--반려-->
					<sf-button size="sm" v-if="isButton_(scrId, 'GV')" line icon="circle-close" :onClick="OpenApprPopup1">
						{{ getMessage_('QWCC001003') }}
					</sf-button>
				</template>

				<!--임시저장-->

				<!--삭제-->
				<sf-button size="sm" v-if="clamMstPopUp.btnDelAuth" line icon="trash" color="error" :onClick="delAction">
					{{ getMessage_('MWCC000328') }}
				</sf-button>
				<!--신청-->
				<sf-button size="sm" v-if="clamMstPopUp.btnApAuth" line icon="round-check-on" :onClick="appSaveAction">
					{{ getMessage_('QWCC001005') }}
				</sf-button>
			</div>
		</div>

		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-20">
				<template v-if="!isLoading">
					<sf-card class="p-0 border-0 bg-transparent h-100">
						<clam-mst-popup-table-info1
							ref="tableInfo1"
							:scrId="scrId"
							:sendParam1="sendParam1"
							@OpenDelPopup="OpenDelPopup"
						></clam-mst-popup-table-info1>
						<clam-mst-popup-table-info2 ref="tableInfo2" :scrId="scrId"></clam-mst-popup-table-info2>
						<clam-mst-popup-table-info3 ref="tableInfo3" :scrId="scrId"></clam-mst-popup-table-info3>
						<clam-mst-popup-table-info4 ref="tableInfo4" :scrId="scrId"></clam-mst-popup-table-info4>
						<clam-mst-popup-table-info5 ref="tableInfo5" :scrId="scrId"></clam-mst-popup-table-info5>
						<clam-mst-popup-table-info6 ref="tableInfo6" :scrId="scrId"></clam-mst-popup-table-info6>

						<com-appr-rson-popup ref="apprRsonPop" :scrId="scrId"></com-appr-rson-popup>
						<!--딜러팝업-->
						<comp-popup ref="compPopup" @SendCpnyData="sendData1" @Refresh="Refresh" :scrId="scrId" />
						<!--기각-->
						<com-appr-rson-popup ref="pmcApprRsonPopup" @apprRsonfresh="apprRsonfresh" :scrId="scrId" />
					</sf-card>
				</template>
			</div>
		</div>
	</sf-modal-layout>
</template>
<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import * as Yup from 'yup';

import ClamMstPopupTableInfo1 from './Table/ClamMstPopupTableInfo1.vue';
import ClamMstPopupTableInfo2 from './Table/ClamMstPopupTableInfo2.vue';
import ClamMstPopupTableInfo3 from './Table/ClamMstPopupTableInfo3.vue';
import ClamMstPopupTableInfo4 from './Table/ClamMstPopupTableInfo4.vue';
import ClamMstPopupTableInfo5 from './Table/ClamMstPopupTableInfo5.vue';
import ClamMstPopupTableInfo6 from './Table/ClamMstPopupTableInfo6.vue';

import ComApprRsonPopup from '@qms/comm/commpopup/ComApprRsonPopup/ComApprRsonPopup.vue';
import CompPopup from '@qms/comm/commpopup/CpnyPopup/CpnyPopup.vue'; //납품업체

import { convertNvl } from '@/qmsUtils/'; //공통함수 import

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		//해당 컴포넌트안에서 사용하는 상태 정의(지역변수)
		return {
			display: false,
			isLoading: false,
			clamMstPopUpInfo: {
				title: '', //타이틀명
				clmNo: '', //클레임번호번호
				roNo: '', //RO번호
				fileList: []
			},
			sendParam1: {} //딜러펍업
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		schema() {
			return Yup.object().shape({
				//URL체크 ARRAY 형식이 아닌 단독으로 VALIDATION 체크

				aplRpymAmt: Yup.string() //적용변제금액
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001306')])), ////{0}은(는) 팔수 입력 값 입니다. , 품번

				aplDvswRt: Yup.string() //적용분담율
					.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001305')])) ////{0}은(는) 팔수 입력 값 입니다. , 품번
					.matches(/^[\d]*\.?[\d]{0,2}$/, this.$sf_formatString(this.getMessage_('QWCC001385'), [this.getMessage_('QWCC001305')])),

				// aplCpnyCd: Yup.string().required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001341')])) //{0}은(는) 팔수 입력 값 입니다. , 납품업체
			    // dlvgNm: Yup.string() //적용변제금액
				// 	.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001924')])), ////{0}은(는) 팔수 입력 값 입니다. , 품번
				// dvswRt: Yup.string() //적용변제금액
				// 	.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001980')])), ////{0}은(는) 팔수 입력 값 입니다. , 품번
				// rpymAmt: Yup.string() //적용변제금액
				// 	.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001295')])), ////{0}은(는) 팔수 입력 값 입니다. , 품번

			});
		}
	},
	components: {
		ClamMstPopupTableInfo1,
		ClamMstPopupTableInfo2,
		ClamMstPopupTableInfo3,
		ClamMstPopupTableInfo4,
		ClamMstPopupTableInfo5,
		ClamMstPopupTableInfo6,
		ComApprRsonPopup /*기각사유 */,
		CompPopup /*딜러점팝업*/
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		Refresh() {},
		apprRsonfresh() {
			this.close();
			this.$emit('Refresh');
		},
		async open(param) {
			this.display = true;
			this.isLoading = true;
			this.$sf_toggleLoading(true);

			this.clamMstPopUpInfo.title = param.title;
			this.clamMstPopUpInfo.roNo = param.roNo; //'RO202207300031'; //'RO202207300011'; //param.roNo; //; //param.roNo; /*ro현황에서 디테일 조회시 RO번호가 넘어옴*/
			this.clamMstPopUpInfo.clmNo = param.clmNo; /*PWA신청 현황에서는 PWANo번호만 넘어옴*/
			let paramRoNo = this.clamMstPopUpInfo.roNo; //'RO202208010001'; //this.roApcnPopupInfo.roNo; //this.roApcnPopupInfo.roNo; //'RO202208010008';
			//let paramClamNo = 'CLM202208100001'; //this.clamMstPopUpInfo.clmNo; //
			let paramClamNo = this.clamMstPopUpInfo.clmNo; //; //
			

			//초기화
			this.setStateApcnInit_();

			try {
				if (paramClamNo) {
					//console.log('클레임번호 문서번호>>>', paramClamNo);

					const searchClamNo = {
						clmNo: paramClamNo,
						paramState: ''
					};

					await this.getClamNoPopList_(searchClamNo);

					await this.setBtnAuth();
				} else if (paramRoNo) {
					//ro번호 조회
					//console.log('처음등록 Ro번호 기준 문서번호>>>', paramRoNo);

					const roNoParam = {
						roNo: paramRoNo,
						paramState: ''
					};

					const { code, messageCd } = await this.getRoApcnPopList_(roNoParam);

					if (code === 3) {
						this.$sf_toast({
							type: code === 0 ? 'ok' : 'error',
							message: this.getMessage_(messageCd)
						});
						this.close();
					} else {
						await this.setBtnAuth();
					}
				} else {
					//console.log('Ro번호 없음');
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.isLoading = false;
				this.$sf_toggleLoading(false);
			}

			//조회
		},
		setBtnAuth() {
			//console.log('야호>>>>', this.isButton_(this.scrId, 'TS'));

			//신청권한
			this.setBtnApAuth_(this.isButton_(this.scrId, 'AP'));

			//승인권한
			this.setBtnApprAuth_();
		},
		close() {
			this.isLoading = true;
			this.display = false;
		},
		OpenDelPopup(param) {
			this.$refs.compPopup.open(param); //.open(param);
		} /*,
		OpenPopupCommCode(param) {
			//console.log('공통팝업 에서의 param 값 ::::: ', param);

			this.$refs.comCdPopup.open(param); //.open(param);
		},
		OpenPopupPartNo(param) {
			//console.log('원인부품팝업 에서의 param 값 ::::: ', param);

			this.$refs.partPopup.open(param); //.open(param);
		},
		OpenGridPartPopup(param) {
			//console.log('교환부품 그리드 팝업 에서의 param 값 ::::: ', param);

			this.$refs.partGridPopup.open(param); //.open(param);
		},
		OpenPmcPopup(param) {
			//console.log('차량정보에서 PMC팝업 에서의 param 값 ::::: ', param);

			this.$refs.pmcNoPopup.open(param); //.open(param);
		}*/,
		OpenApprPopup1() {
			/*반려*/
			let paramList = {
				apprState: 'R', //반려
				btnMsg: this.getMessage_('QWCC001003'), //반려
				labelMsg: this.getMessage_('QWCC001146'), //반려
				title: this.getMessage_('QWCC001146'), //반려사유
				cfMsg: this.getMessage_('QWCC001150'), //반려하시겠습니까>?
				apiType: 'CLM',
				masterKey1: this.clamMstPopUpInfo.clmNo
			};

			this.$refs.pmcApprRsonPopup.open(paramList); //.open(param);
		},
		sendData1(param) {
			//alert('최종 팝업화면에서 가지고온 데이터 ::::: cmpnCd 는 ' + param.cmpnCd + ', cmpnNm은 ' + param.cmpnNm);
			//console.log('result1값으', param);

			this.sendParam1 = param; //watch감시용
		},
		sendData2(param) {
			//console.log('result2', param);
			//alert('최종 팝업화면에서 가지고온 데이터 ::::: cmpnCd 는 ' + param.cmpnCd + ', cmpnNm은 ' + param.cmpnNm);
			this.sendParam2 = param; //watch감시용
		},
		sendData3(param) {
			//pwa 기초정보 원인부품팝업전용
			//console.log('result3', param);
			//alert('최종 팝업화면에서 가지고온 데이터 ::::: cmpnCd 는 ' + param.cmpnCd + ', cmpnNm은 ' + param.cmpnNm);
			this.sendParam3 = param; //watch감시용
		},
		sendData4(param) {
			//교환부품정보 END품팝업
			//console.log('result4', param);
			//alert('최종 팝업화면에서 가지고온 데이터 ::::: cmpnCd 는 ' + param.cmpnCd + ', cmpnNm은 ' + param.cmpnNm);
			this.$refs.tableInfo4.gridParNoPopUp(param);

			this.sendParam4 = param; //watch감시용
		},
		sendData5(param) {
			//pmc번호전용

			//console.log('result5', param);

			this.sendParam5 = param; //watch감시용
		},
		async afterSaveClose() {
			//팝업창 닫고 재조회
			this.$sf_toggleLoading(true);
			this.close();
			this.$emit('Refresh');
		},
		async appSaveAction() {
			//console.log(this.saveClamMst);
			//신청
			await this.setState_({ key: 'isSaveFlag', value: true });

			try {
				// 유효성 검사
				await this.schema.validateSync(this.saveClamMst);
				if(this.saveClamMst.ctype=='W' || this.saveClamMst.ctype=='S'){
					if(this.saveClamMst.dlvgNm=='' || this.saveClamMst.dlvgNm==null ){
						// this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001924')])
						throw new TypeError(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001924')]));
						// this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001129') });
						// return;
					}
					if(this.saveClamMst.dvswRt=='' || this.saveClamMst.dvswRt==null ){
						// this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001129') });
						// return;
						throw new TypeError(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001980')]));
					}
					if(this.saveClamMst.rpymAmt=='' || this.saveClamMst.rpymAmt==null ){
						// this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001129') });
						// return;
						throw new TypeError(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC001295')]));
					}
				}
				//교환부품정보 등록이 되어있나
				if (this.clamMstSwapPartsList.length === 0) {
					this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001129') });
					return;
				}

				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('QWCC001152'), //신청하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001005'), clickFn: () => this.save('20') }], //신청,
					closeFn: () => this.setState_({ key: 'isSaveFlag', value: false })
				});
			} catch (error) {
				this.setState_({ key: 'isSaveFlag', value: false });
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.setState_({ key: 'isSaveFlag', value: false });
			}
		},
		async apprSaveAction() {
			//승인처리
			await this.setState_({ key: 'isSaveFlag', value: true });

			try {
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('QWCC001155'), //승인하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001001'), clickFn: () => this.apprSave() }], //승인,
					closeFn: () => this.setState_({ key: 'isSaveFlag', value: false })
				});
			} catch (error) {
				this.setState_({ key: 'isSaveFlag', value: false });
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.setState_({ key: 'isSaveFlag', value: false });
			}
		},
		async save(paramState) {
			//저장
			let formData = new FormData();

			//State를 formData에 Key Value로 넣습니다.
			//폼객체에 API 구분값을 담는다.
			Object.keys(this.saveClamMst).forEach(key => formData.append(key, convertNvl(this.saveClamMst[key], '')));

			//paramState값은 10은 임시저장, 20번 신청
			formData.append('state', paramState);

			await this.saveClamMstPopup_({ formData })
				.then(response => {
					if (response.header.message != undefined && response.header.message != null) {
						this.$sf_toast({
							type: response.header.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.header.messageCd)
						});
					}

					//임시저장후
					//재조회를 한후 처리상태 컴포넌트에 pwaNo. 처리단계 신청일 확정일등을
					//임시저장상태
					if (paramState === '10') {
						//alert('값이뭐냐' + response.body.pwaNo);

						const searchClamNo = {
							clmNo: response.body.clmNo,
							paramState
						};

						this.getClamNoPopList_(searchClamNo).then(response => {
							//다시 셋팅함.
							this.$refs.tableInfo1.setProcessInfo();
							this.$refs.tableInfo2.setProcessInfo();
							this.$refs.tableInfo3.setProcessInfo();
							this.$refs.tableInfo4.setProcessInfo();
							this.$refs.tableInfo6.setProcessInfo();
						});
					} else {
						//모달창 닫고 재조회
						this.afterSaveClose();
					}
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		async apprSave() {
			//승인처리
			await this.saveStateAppr_()
				.then(response => {
					if (response.header.message != undefined && response.header.message != null) {
						this.$sf_toast({
							type: response.header.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.header.messageCd)
						});
					}
					//모달창 닫고 재조회
					this.afterSaveClose();
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
		/*
		sendData(param) {
			//alert('여기가맛나');
			//alert('최종 팝업화면에서 가지고온 데이터 ::::: url 는 ' + param.url + ', title은 ' + param.title);
		}
		*/
	},
	created() {
		console.clear();
	}
};
</script>

<style></style>
